import React, { useState } from "react";
import { getAccessKey, setAccessKey, verifyAccessKey } from "../auth/accessKey";
import "./AccessKeyGate.css";

// Shows the key prompt until a valid key is stored, then renders the app.
const AccessKeyGate = ({ children }) => {
	const [hasKey, setHasKey] = useState(() => Boolean(getAccessKey()));
	const [value, setValue] = useState("");
	const [error, setError] = useState("");
	const [checking, setChecking] = useState(false);

	if (hasKey) return children;

	const submit = async (e) => {
		e.preventDefault();
		const key = value.trim();
		if (!key) return;
		setChecking(true);
		setError("");
		try {
			if (await verifyAccessKey(key)) {
				setAccessKey(key);
				setHasKey(true);
			} else {
				setError("That key is not valid.");
			}
		} catch {
			setError("Could not reach the Control Center API. Try again.");
		} finally {
			setChecking(false);
		}
	};

	return (
		<div className="access-gate">
			<form className="access-gate-card" onSubmit={submit}>
				<h1>Control Center</h1>
				<p>Enter your access key to continue.</p>
				<input
					type="password"
					autoFocus
					autoComplete="current-password"
					placeholder="Access key"
					aria-label="Access key"
					value={value}
					onChange={(e) => setValue(e.target.value)}
				/>
				{error && (
					<div className="access-gate-error" role="alert">
						{error}
					</div>
				)}
				<button type="submit" disabled={checking || !value.trim()}>
					{checking ? "Checking…" : "Unlock"}
				</button>
			</form>
		</div>
	);
};

export default AccessKeyGate;
